import { Reducer, useReducer, useRef } from 'react';

type ActionType = {
  type: 'open' | 'close';
};

type InitialState = {
  showModal: boolean;
};

const reducer: Reducer<InitialState, ActionType> = (state, action) => {
  switch (action.type) {
    case 'close': {
      return {
        showModal: false,
      };
    }
    case 'open':
      return {
        showModal: true,
      };
    default:
      throw new Error(`Unsupported type: ${action.type}`);
  }
};

const useModal = () => {
  const { current: initialState } = useRef<InitialState>({
    showModal: false,
  });
  const [state, dispatch] = useReducer(reducer, initialState);

  const openModal = () => dispatch({ type: 'open' });
  const closeModal = () => dispatch({ type: 'close' });

  return {
    showModal: state.showModal,
    openModal,
    closeModal,
  };
};

export default useModal;
